<template>
  <component
    :is="getComponentForField(field.type)"
    :field="field"
    :formData="formData"
    :showLabel="showLabel">
  </component>
</template>
<script>
  import TextAreaComponent from '@/components/form/field/TextAreaComponent'
  import TextComponent from '@/components/form/field/TextComponent'
  import DecimalComponent from '@/components/form/field/DecimalComponent'
  import PasswordComponent from '@/components/form/field/PasswordComponent'
  import NumberComponent from '@/components/form/field/NumberComponent'
  import DateComponent from '@/components/form/field/DateComponent'
  import FileComponent from '@/components/form/field/FileComponent'
  import MultipleFileComponent from '@/components/form/field/MultipleFileComponent'
  import CheckboxComponent from '@/components/form/field/CheckboxComponent'
  import MultipleCheckboxComponent from '@/components/form/field/MultipleCheckboxComponent'
  import RadioComponent from '@/components/form/field/RadioComponent'
  import SelectComponent from '@/components/form/field/SelectComponent'
  import PostalCodeComponent from '@/components/form/field/PostalCodeComponent'
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'
  import RangeComponent from '@/components/form/field/RangeComponent'
  import EmailComponent from '@/components/form/field/EmailComponent'
  import { fieldTypesSpecs } from '@/display_context/details_context'

  export default {
    components: {
      TextAreaComponent,
      EmailComponent,
      RangeComponent,
      TextComponent,
      DecimalComponent,
      PasswordComponent,
      NumberComponent,
      DateComponent,
      FileComponent,
      MultipleFileComponent,
      CheckboxComponent,
      MultipleCheckboxComponent,
      RadioComponent,
      SelectComponent,
      PostalCodeComponent
    },
    name: 'form-field-component',
    data () {
      return {
        fieldTypesSpecs: fieldTypesSpecs
      }
    },
    props: {
      field: {
        type: FormField,
        required: true
      },
      formData: {
        type: FormData
      },
      showLabel: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      getComponentForField (type) {
        return this.fieldTypesSpecs.find(i => i.type === type.toLowerCase()).component
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
